import TenantMuti from './tenantMuti.vue'
export default TenantMuti
